import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEmail3"><Path d="M22 6.79797V4H2V6.79797C4.54103 9.39107 8.08262 11 12 11C15.9174 11 19.459 9.39107 22 6.79797Z" fill="currentColor"/><Path d="M22 9.49072C19.2608 11.6865 15.7838 13 12 13C8.21621 13 4.7392 11.6865 2 9.49072V20H22V9.49072Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail3;
